import React from 'react'
import { Outlet } from 'react-router-dom'
import { useParams, useNavigate } from 'react-router-dom'
import { getVisitors_act } from '../../redux/ducks/visitors/actions' 
import { connect } from 'react-redux'
import { getTahunConfig_act } from '../../redux/ducks/settings/actions'

const YearConfig = (props) => {
  const navigate = useNavigate()
  const { yearconfig } = useParams()
  React.useEffect(() => {
      let years = []
      if(props.tahunConfig.yearlist !== null){
        
        years = props.tahunConfig.yearlist.map(item => item.toString())
        
      }
      else{
        props.getTahunConfig().then((response) => {
          if(response.status === "success"){
            years = response.data.result.yearlist.map(item => item.toString())
          }
          else years = [new Date().getFullYear().toString()]
        })
        
      }

      if(!years.includes(yearconfig)){
          navigate('/')
      }
  },[yearconfig, navigate])

  React.useEffect(() => { props.getVisitors() },[])

  React.useEffect(() => {
      const intervalId = setInterval(() => {
          props.getVisitors()
      }, (180 * 1000))

      // Membersihkan interval saat komponen unmount
      return () => clearInterval(intervalId);
  },[])

  return (
    <Outlet />
  )
}

const mapStateToProps = (state) => ({
  visitors: state.visitorsState.visitors.data,
  tahunConfig: state.settingsState.tahunConfig,

})

const mapDispatchToProps = {
  getVisitors: getVisitors_act,
  getTahunConfig: getTahunConfig_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(YearConfig)